
/**
 * 
 * @param {Boolean} optinState 
 * @returns 
 */
export function isOptinChecked(optinState) {
    return optinState;
}

/**
 * prevent postal code value max length
 * @param {Event} $event 
 */
export function preventPostalCodeMaxLength($event) {
    if(
      ($event.target.value.length >= 5 && $event.keyCode != 8) || 
      $event.key == "-" || 
      $event.key == "." ||
      $event.key == ","
      ) {
      $event.preventDefault();
    }  
}